<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>对账单</el-breadcrumb-item>
            <el-breadcrumb-item>订单汇总</el-breadcrumb-item>
        </el-breadcrumb>

        <el-row class="sunFinance" v-if="bill">
            <el-col :span="6">供应金额：<span>{{bill.order_total}}</span> 元</el-col>
            <el-col :span="6">运费金额：<span>{{bill.express_total}}</span> 元</el-col>
            <el-col :span="6">退款金额：<span>{{bill.refund_total}}</span> 元</el-col>
            <el-col :span="6"></el-col>
        </el-row>
        <el-row class="sunFinance" v-if="bill">
            <el-col :span="18">
                <el-date-picker size="small" @change="changeTime"  style="margin-left: 10px" v-model="times" type="datetimerange"
                                range-separator="至" start-placeholder="结算开始日期" end-placeholder="结算结束日期">
                </el-date-picker>
                <el-popconfirm title="您确定要生成对账单吗？" @confirm="createBill" class="l10"  v-auth="['supplier/finance/createOrderbill']">
                    <el-button size="mini" style="margin-left: 20px" type="primary" slot="reference" v-auth="['supplier/finance/createOrderbill']">生成对账单</el-button>
					 <el-button size="mini" style="margin-left: 20px" type="primary" slot="reference"  @click="downloadFile()">下载付款申请通知模板</el-button>
                </el-popconfirm>
            </el-col>
            <el-col :span="6">合计：<span>{{bill.order_count}}</span> 单 金额：<span>{{bill.result_totals}}</span> 元</el-col>
        </el-row>
        <table class="table" v-if="bill" width="100%" cellpadding="0" cellspacing="0">
            <tr>
                <th>商品</th>
                <th>单价/数量</th>
                <th>总金额</th>
                <th>调整金额</th>
                <th>来源</th>
                <th width="120">买家</th>
                <th width="80">退款金额</th>
            </tr>
            <template v-for="(item, index) in list">
                <tr>
                    <th colspan="8">{{item.created_date}} 订单编号：{{item.order_sn}}</th>
                </tr>
                <tr v-for="(val , key) in item.order_goods">
                    <td>
                        <div class="thumb">
                            <img :src="val.pic_url">
                            {{val.product_name}}（{{val.sku_name}}）
                        </div>
                    </td>
                    <template v-if="val.supplier_id > 0">
                    <td>
                        {{val.cost_price}}元/{{val.number}} 件
                    </td>
                    <td>
                        <el-tag size="small">{{val.supplier_cost_price}} 元</el-tag><br>
                    </td>
                    </template>
                    <template v-else>
                        <td>
                            {{val.supplier_price}}元/{{val.number}} 件
                        </td>
                        <td>
                            <el-tag size="small">{{val.supplier_total_price}} 元</el-tag><br>
                        </td>
                    </template>
                    <td>
                        {{val.supplier_adjust_money}}元
                    </td>
                    <template v-if="!key">
                    <td :rowspan="item.order_goods.length">
                        {{item.supplier_id ? (item.supplier ? item.supplier.name : '非自营') : '自营'}}
                    </td>
                    </template>
                    <template v-if="!key">
                    <td :rowspan="item.order_goods.length">
                        {{item.buyer ? item.buyer.nick_name : ''}}
                        {{item.buyer ? item.buyer.mobile : ''}}
                    </td>
                    </template>
                    <td>
                        <span v-if="val.refund">{{val.refund_money}}</span>
                        <span v-else>0</span>
                    </td>
                </tr>
            </template>
        </table>
    </div>
</template>
<script>
    export default {
        name: 'create_bill',
        data() {
            return {
                bill: null,
                list: [],
                isLoad: false,
                times: []
            }
        },
        created() {
            this.loadList()
        },
        methods: {
            changeTime: function () {
                this.loadList()
            },
            loadList() {
                this.isLoad = true
                this.axios.get('supplier/finance/createOrderbill',{
                    params: {
                        times: this.times
                    }
                }).then(res => {
                    this.isLoad = false
                	this.list = res.data.list
                    this.bill = res.data.bill
                }).catch(() => {
                    this.isLoad = false
                }).finally(() => {
                    this.isLoad = false
                })
            },
            createBill: function () {
                var _this = this
                this.isLoad = true
                this.axios.post('supplier/finance/createOrderbill',{
                    times: this.times
                }).then(res => {
                    if (res.code == 1) {
                        this.isLoad = false
                        this.$message.success({
                            message: '生成成功'
                        });
                        setTimeout(function () {
                            _this.goBack()
                        }, 1500)
                    } else {
                        this.$message.success({
                            message: res.msg
                        });
                    }
                }).catch(() => {
                    this.isLoad = false
                }).finally(() => {
                    this.isLoad = false
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
			downloadFile() {
				window.open('https://supply.oss.xm0592.com/orderpay_apply.docx')
			},
        },

    }
</script>
<style scoped>
    .sunFinance {
        margin-bottom: 20px;
        text-align: center;
    }

    .sunFinance .el-col {
        height: 50px;
        line-height: 50px;
        font-size: 16px;

        border: 1px solid #EBEEF5;
        border-right: none;
    }

    .sunFinance .el-col:last-child {
        border-right: 1px solid #EBEEF5;
    }

    .sunFinance span {
        font-size: 20px;
        color: red;
    }

    .table {
        width: 100%;
        border-collapse: collapse;
    }

    .table td {
        border: 1px solid #EBEEF5;
        padding: 12px 10px;
        color: rgb(96, 98, 102);
        line-height: 23px;
    }

    .table th {
        line-height: 23px;
        border: 1px solid #EBEEF5;
        padding: 12px 10px;
        text-align: left;
        background: #f5f7fa;
        color: rgb(144, 147, 153);
    }
</style>
